<template>
  <div class="profile-container">
    <div class="grid">
      <div class="flex-col">
        <span>Name: </span>
        <span>{{ user.firstName }} {{ user.lastName }}</span>
      </div>
      <div class="flex-col">
        <span>Username: </span>
        <span>{{ user.username }}</span>
      </div>
      <div class="flex-col">
        <span>Email: </span>
        <span>{{ user.email }}</span>
      </div>
      <div class="flex-col">
        <label for="password">Change password: </label>
        <input id="password" />
        <input id="passwordConfirm" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "profile-info",
  props: { user: Object }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 2rem;

  span {
    display: flex;
    word-wrap: break-word;
  }
}
</style>
